import { cn } from "src/utils/cn";

import Loader from "./loader";

const Loading = ({ className }: { className?: string }) => (
  <div className={cn("h-[100dvh] w-full flex items-center justify-center", className)}>
    <Loader />
  </div>
);

export default Loading;
